import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';
import store from '../../store';
import {getSelectedPlan, toggleLoader, handlePromise, getSelectedGatewayOnLoad, isApplePayPreferredBrowser} from '../../lib';
import {setState} from "../../index";

let state = store.state.cartState ? store.state.cartState : {};

export default class ApplePayGateway extends PaymentGatewayProcessor {
  processCheckout() {
    return new Promise(async (resolve, reject) => {
      try {
        toggleLoader(false);
        const recurlyTokenElement = document.querySelector('#recurly_token');

        if (applePay._ready) {
          // window.total_price can change after Apple Pay was initialized (plan/addon
          // switch, VAT recalculation). recurly.js reads _paymentRequest.total lazily
          // when begin() opens the sheet, so refresh it here instead of trusting the
          // value captured at init time in loadApplePayIfApplicable().
          if (window.total_price) {
            applePay._paymentRequest.total.amount = String(window.total_price);
          }
          applePay.begin();
        } else {
          reject('An error occured while processing payment from ApplePay! please try again later!');
        }

        applePay.on('token', async token => {
          toggleLoader(true);
          recurlyTokenElement.value = token.id;
          const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutInit());
          if (checkoutApiCallErr) return reject(checkoutApiCallErr);
          resolve(checkoutApiCallRes);
        });

        applePay.on('error', err => {
          console.error('Apple Pay error', err);
          toggleLoader(false);
          reject(err);
        });
      } catch (err) {
        throw reject(err);
      }
    });
  }

  static loadApplePayIfApplicable(GatewaysInstance) {
    // Android (phone or tablet Chrome) has no Wallet/ApplePaySession backing even
    // though the cross-browser Apple Pay SDK defines window.ApplePaySession there,
    // so applePay.ready() below never fires and conditionalGateways.applepay is
    // left `undefined` — gateways.js only hides a tab on `=== false`, so the tab
    // rendered with an empty panel. Bail out early and hide it explicitly instead.
    if (/Android/.test(navigator.userAgent)) {
      conditionalGateways.applepay = false;
      GatewaysInstance.render();
      return;
    }

    // Check if apple pay is attached with any of plan
    let applePayPlans = state.plans.filter(function (plan) {
      let filteredGateways = plan.gateways.filter(function (gateway) {
        return gateway.logical_key.toLowerCase() == 'applepay';
      });

      return filteredGateways.length;
    });

    // Initialize apple pay when its attached with any of plan
    if (applePayPlans.length) {
      applePay = recurly.ApplePay({
        country: 'US',
        currency: state.currency_code,
        label: getSelectedPlan().package_plan_label,
        total: window.total_price || 1,
      });

      applePay.ready(function () {
        console.log('Apple Pay ready');
        conditionalGateways.applepay = true;

        // Select Apple Pay if it's the plan's first gateway, or if this browser
        // prefers Apple Pay (Safari on Mac, any browser on iOS/iPadOS) regardless
        // of where Apple Pay sits in the plan's configured gateway order.
        let selectedGateway = getSelectedGatewayOnLoad();
        const shouldSelectApplePay =
          selectedGateway.gateway_key === 'applepay' || isApplePayPreferredBrowser();

        if (shouldSelectApplePay) {
          setState({
            selected_gateway: 'applepay',
            selected_gateway_name: 'Apple Pay',
          });
        }
        GatewaysInstance.render();
      });
    }
  }
}
